"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identity = void 0;
/**
 * Represents identity information
 */
var Identity = /** @class */ (function (_super) {
    __extends(Identity, _super);
    function Identity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Identity";
        /**
         * The identity id
         */
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        /**
         * The tenant id
         */
        _this.tenantId = function () {
            _this.push(function (_) { return "tenantId"; });
        };
        /**
         * The name of the identity
         */
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        /**
         * The available languages of the identity
         */
        _this.availableLanguages = function () {
            _this.push(function (_) { return "availableLanguages"; });
        };
        /**
         * The order of languages that will be used in case of missing translations
         */
        _this.languageOrder = function () {
            _this.push(function (_) { return "languageOrder"; });
        };
        /**
         * Intent cascading setting
         */
        _this.intentCascading = function () {
            _this.push(function (_) { return "intentCascading"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Identity;
}(Array));
exports.Identity = Identity;
//# sourceMappingURL=Identity.js.map